import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SharedUiModule } from '@emi/shared/ui';
import { SkuCapsuleUiModule } from '@emi/sku-capsule/ui';
import { SkuCapsuleComponent } from './sku-capsule.component';
import { SkuCapsuleFeatureSkuSummaryModule } from '@emi/sku-capsule/feature/sku-summary';
import { SkuCapsuleFeatureSkuDataModule } from '@emi/sku-capsule/feature/sku-data';
import { SkuCapsuleFeatureSkuFeedbackModule } from '@emi/sku-capsule/feature/sku-feedback';

@NgModule({
  imports: [
    CommonModule,
    MatTabsModule,
    MatTooltipModule,
    SkuCapsuleUiModule,
    SharedUiModule,
    SkuCapsuleFeatureSkuSummaryModule,
    SkuCapsuleFeatureSkuDataModule,
    SkuCapsuleFeatureSkuFeedbackModule
  ],
  declarations: [
    SkuCapsuleComponent
  ],
  exports: [
    SkuCapsuleComponent
  ],
})
export class SkuCapsuleFeatureSkuCapsuleModule {}
